var extend = require('util')._extend

const paths = ['', 'login', 'wizard', 'plans', 'contracts', 'subscribers', 'signup', 'sellers', 'invoices', 'entries', 'contract_plans', 'settings', 'subscribe', 'customers', 'help', 'validators', 'empty-list', 'payments', 'access_users', 'service_taxes', 'taxes', 'orders']

function loadFile (path, key) {
  try {
    return convertFile(path, key)
  } catch (e) {
    return {}
  }
}

function convertFile (path, key) {
  if (path.length) { path += '/' }
  return require('json!yaml!./' + path + key + '.yml')
}

function importLocales (key) {
  var locales = {}
  paths.forEach(function (path) {
    var json = loadFile(path, key)
    locales = extend(locales, json)
  })
  return locales
}

module.exports = {
  ptBR: importLocales('pt-BR')
}



// WEBPACK FOOTER //
// ./src/lang/parser.js